/* eslint-disable max-lines-per-function --
   TODO: 招募前 sprint 拆組件 (TODO-frontend-eslint-ci-warnings-as-errors)。
   2026-02-06 規則加入時 87 個既有違規凍結為 baseline，新檔/新函數仍受 hook 攔截。
*/
// frontend/src/components/Auth/Login.jsx
// 登入表單元件

import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Alert,
  CircularProgress,
  Paper,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff, AccountCircle, Lock } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';
import authService from '../../services/authService';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [remainingAttempts, setRemainingAttempts] = useState(null);

  // 處理輸入變更
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'rememberMe' ? checked : value,
    }));
    // 清除錯誤訊息
    setError('');
  };

  // 處理表單提交
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 表單驗證
    if (!formData.username || !formData.password) {
      setError('請輸入使用者名稱和密碼');
      return;
    }

    setLoading(true);
    setError('');
    setRemainingAttempts(null);

    try {
      // 呼叫登入 API
      const response = await authService.login(formData.username, formData.password);

      if (response.success) {
        // 儲存使用者資訊（Token 已由 authService.login 內部處理）
        const storage = formData.rememberMe ? localStorage : sessionStorage;
        storage.setItem('user', JSON.stringify(response.data.user));

        // 更新認證狀態（傳遞完整的 token 資料）
        login(response.data, response.data.user);

        // 導向首頁或之前的頁面
        const from = location.state?.from?.pathname || '/';
        navigate(from, { replace: true });
      }
    } catch (err) {
      console.error('登入錯誤:', err);

      // 處理錯誤訊息
      if (err.response?.data?.message) {
        setError(err.response.data.message);

        // 顯示剩餘嘗試次數
        if (err.response.data.remainingAttempts !== undefined) {
          setRemainingAttempts(err.response.data.remainingAttempts);
        }
      } else {
        setError('登入失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  };

  // 切換密碼顯示
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Paper elevation={3} sx={{ padding: 4, width: '100%', maxWidth: 400 }}>
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
        {/* 錯誤訊息 */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
            {remainingAttempts !== null && (
              <Box component="span" sx={{ display: 'block', mt: 1 }}>
                剩餘嘗試次數: {remainingAttempts}
              </Box>
            )}
          </Alert>
        )}

        {/* 使用者名稱 */}
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label="使用者名稱"
          name="username"
          autoComplete="username"
          autoFocus
          value={formData.username}
          onChange={handleChange}
          disabled={loading}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AccountCircle />
              </InputAdornment>
            ),
          }}
        />

        {/* 密碼 */}
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="密碼"
          type={showPassword ? 'text' : 'password'}
          id="password"
          autoComplete="current-password"
          value={formData.password}
          onChange={handleChange}
          disabled={loading}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Lock />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                  disabled={loading}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* 記住我 */}
        <FormControlLabel
          control={
            <Checkbox
              name="rememberMe"
              color="primary"
              checked={formData.rememberMe}
              onChange={handleChange}
              disabled={loading}
            />
          }
          label="記住我"
          sx={{ mt: 1, mb: 2 }}
        />

        {/* 登入按鈕 */}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 2, mb: 2 }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : '登入'}
        </Button>

        {/* 其他選項 */}
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Button size="small" onClick={() => navigate('/forgot-password')} disabled={loading}>
            忘記密碼？
          </Button>
          <Box sx={{ mt: 1 }}>
            <Button size="small" onClick={() => navigate('/register')} disabled={loading}>
              還沒有帳號？立即申請
            </Button>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default Login;
